import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RootStore } from "./root.store";

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [RootStore],
})
export class StoreModule {}
